/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { StringBuilder } from "igniteui-react-core";
/**
 * @hidden
 */
var SuffixVisualModelExport = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SuffixVisualModelExport, _super);
    function SuffixVisualModelExport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.a = 0;
        _this.c = false;
        _this.b = false;
        _this.d = null;
        return _this;
    }
    SuffixVisualModelExport.prototype.e = function () {
        var a = new StringBuilder(0);
        a.l("{");
        a.l("shiftType : " + this.a + ", ");
        a.l("isHover : " + this.c + ", ");
        a.l("isDisabled : " + this.b + ", ");
        a.l("name : \"" + this.d + "\", ");
        a.l("}");
        return a.toString();
    };
    SuffixVisualModelExport.$t = markType(SuffixVisualModelExport, 'SuffixVisualModelExport');
    return SuffixVisualModelExport;
}(Base));
export { SuffixVisualModelExport };
//# sourceMappingURL=SuffixVisualModelExport.js.map
